<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('fighters.edit', { id: vm.$route.params.fighterId })
  }),
  computed: {
    ...mapState('fighters', ['routeKey', 'routes', 'form', 'item']),
    crumbs: vm => [
      { text: vm.$t('fighters.title'), to: { name: 'fighters.index' } },
      { text: vm.$t('fighters.edit', { id: vm.$route.params.fighterId }) }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('fighters/fetchItem', { route: to })
      await store.dispatch('fighters/fetchCategories')
      await store.dispatch('fighters/fetchSiteVersions')
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('fighters', ['createItem', 'updateItem'])
  }
}
</script>
